import { Col, Row } from "antd";
import styled from "styled-components";
import { color } from "../resources";

type Props = {
  className?: string;
  as?: React.ElementType | keyof JSX.IntrinsicElements;
};

export const Center: React.FC<{
  children: React.ReactNode | JSX.Element | JSX.Element[];
}> = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Required = styled.div`
  color: ${color.red};
  position: relative;
  top: 3px;
`;

export const RowComponent: React.FC<{
  children: any;
}> = styled(Row)`
  display: flex;
  align-items: center;
`;

export const ColComponent: React.FC<{
  children: any;
  xs?: any;
  md?: any;
  xl?: any;
  lg?: any;
}> = styled(Col)`
  display: flex;
  flex-direction: column;
`;
